import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  AccessPermissionService,
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  DISTANCE_KM_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { CustomFacade } from '@piqet-angular/data';
import { Subject, take } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';

@Injectable({
  providedIn: 'root',
})
export class CustomTransportDataGridService {
  customTransportPayload: any;
  addCustomTransportPayload: any;
  event: any;
  Access: any;

  ediTransportSub = new Subject<[any, any, any, any]>();
  customTransportObservable$ = this.ediTransportSub.asObservable();

  deleteTransportSub = new Subject<[any, any, any]>();
  deleteCustomTransportObservable$ = this.deleteTransportSub.asObservable();

  copyTransportSub = new Subject<[any, any, any]>();
  copyCustomTransportObservable$ = this.copyTransportSub.asObservable();

  inlineEditing = new Subject<[any, any]>();
  inlineEditingObservable$ = this.inlineEditing.asObservable();

  editCustomTransportManualLocation = new Subject<[any, any]>();
  editCustomTransportManualLocationData$ = this.editCustomTransportManualLocation.asObservable();

  checkDeleteCustomTransportMnLocation = new Subject<[any, any, boolean]>();
  checkDeleteCustomTransportMnLocationData$ =
    this.checkDeleteCustomTransportMnLocation.asObservable();
  allTransportLocationRecords: any;
  currentRoute: string = '';
  constructor(
    private CustomFacade: CustomFacade,
    private accessService: AccessPermissionService,
    private swalService: SwalService
  ) {}

  accessAllPermission(type: string) {
    const access =
      this.isAccess(type, 'edit') || this.isAccess(type, 'delete') || this.isAccess(type, 'create');
    return access;
  }

  getCustomTransportDataColumn(pathName?: any): ColDef[] {
    this.currentRoute = pathName;
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'My custom transport chain',
      field: 'name',
      width: 830,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        const checkAccess = this.isAccess(pathName, 'edit') || this.isAccess(pathName, 'view');
        if (checkAccess) {
          cellElement.title = dblclickTooltipDef;
          cellElement.style.textDecoration = 'underline';
        }
        cellElement.addEventListener('dblclick', () => {
          checkAccess &&
            this.ediTransportSub.next([
              params.data,
              params.data.id,
              'Review custom transport chain',
              pathName,
            ]);
        });
        return cellElement;
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: false,
    });

    {
      pathName == 'adminCustomTransport' &&
        colDef.push({
          ...defaultColumn,
          colId: 'OrganizationName',
          headerName: 'Organization name',
          field: 'organizationName',
          width: 830,
          cellClass: 'my-permission-cursor-pointer',
          wrapText: true,
          lockVisible: true,
          autoHeight: true,
          resizable: false,
          filter: 'agTextColumnFilter',
        });
    }

    colDef.push({
      ...defaultColumn,
      colId: 'OwnerName',
      headerName: 'Owner',
      field: 'ownerName',
      width: 830,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: false,
    });

    this.accessAllPermission(pathName) &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        cellRendererParams: {
          showEdit: this.isAccess(pathName, 'edit'),
          showCopy: this.isAccess(pathName, 'create'),
          showDelete: this.isAccess(pathName, 'delete'),
          value: 'customTransport',
          deleteData: (data: any, pathName: any) => {
            if (pathName == 'adminCustomTransport') {
              this.deleteCustomConfirmation(
                data,
                '/AdminCustomTransportScenario/DeleteCustomTransportScenario',
                pathName
              );
            } else {
              this.deleteCustomConfirmation(
                data,
                '/CustomTransportScenario/DeleteCustomTransportScenario',
                pathName
              );
            }
          },
          copyData: (data: any, pathName: any) => {
            if (pathName == 'adminCustomTransport') {
              this.copyTransportSub.next([
                data,
                '/AdminCustomTransportScenario/SaveCopyCustomTransportScenario',
                pathName,
              ]);
            } else {
              this.copyTransportSub.next([
                data,
                '/CustomTransportScenario/SaveCopyCustomTransportScenario',
                pathName,
              ]);
            }
          },
          copyDataEditRendarar: (data: any) => {
            return false;
          },
          editData: (data: any, pathName: any) => {
            this.ediTransportSub.next([data, data.id, 'Review custom transport chain', pathName]);
          },
        },
        sortable: false,
        lockVisible: true,
        lockPosition: right,
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        resizable: false,
      });

    return colDef;
  }

  isAccess = (pathName: any, type: 'view' | 'edit' | 'create' | 'delete') => {
    return pathName.includes('admin')
      ? this.accessService.hasModulePermission(
          rolesModuleName.AdministratorTransportScenarios,
          mainModuleName.projectManagementModule,
          type
        )
      : this.accessService.hasModulePermission(
          rolesModuleName.customTransportScenario,
          mainModuleName.customModule,
          type
        );
  };

  innedGridActionAccess(fromEdit: boolean): boolean {
    return (
      (!fromEdit && this.isAccess(this.currentRoute, 'create')) ||
      (fromEdit && !this.isAccess(this.currentRoute, 'view')) ||
      (fromEdit && this.isAccess(this.currentRoute, 'edit'))
    );
  }

  addCustomTransportDataColumn(): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'OriginName',
      headerName: 'Origin',
      field: 'cityName',
      minWidth: grid_widths_map.lg_column_sm,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport mode',
      field: 'transportModeName',
      minWidth: grid_widths_map.sm_column_sm,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Distance',
      headerName: DISTANCE_KM_LABEL,
      field: 'distance',
      minWidth: grid_widths_map.sm_column_xm,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      cellRendererParams: {
        showDelete: true,
        showEdit: true,
        value: 'customTransport',
        editData: (data: any) => {
          this.editCustomTransportManualLocation.next([data, true]);
        },
        deleteData: (data: any) => {
          this.alertConfirmation(data);
        },
      },
      sortable: false,
      lockVisible: true,
      lockPosition: right,
      maxWidth: grid_widths_map.sm_column_xm,
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      resizable: false,
    });

    return colDef;
  }
  addCustomTransportDataColumnSingle(fromEdit: boolean = false): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'OriginName',
      headerName: 'Origin',
      field: 'cityName',
      minWidth: grid_widths_map.lg_column_sm,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TransportModeName',
      headerName: 'Transport mode',
      field: 'transportModeName',
      minWidth: grid_widths_map.sm_column_sm,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Distance',
      headerName: DISTANCE_KM_LABEL,
      field: 'distance',
      minWidth: grid_widths_map.sm_column_xm,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    this.innedGridActionAccess(fromEdit) &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        cellRendererParams: {
          showDelete: true,
          value: 'customTransport',
          deleteData: (data: any) => {
            this.alertConfirmation(data);
          },
        },
        sortable: false,
        lockVisible: true,
        lockPosition: right,
        maxWidth: grid_widths_map.sm_column_xm,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        resizable: false,
      });

    return colDef;
  }

  alertConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.CustomFacade.customTransportScenarioList$.pipe(take(1)).subscribe((records: any) => {
          this.allTransportLocationRecords = records;
        });
        this.CustomFacade.deleteTransportScenarioActions(data, 'delete');
        this.checkDeleteCustomTransportMnLocation.next([
          this.allTransportLocationRecords,
          data,
          true,
        ]);
      }
    });
  }

  addMultipleCustomTransportDataColumn(fromEdit: boolean = false): ColDef[] {
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'SiteName',
      headerName: 'Site name',
      field: 'siteName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Product',
      headerName: 'Product(%)',
      field: 'productPercentage',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'cityName',
      headerName: 'Origin',
      field: 'cityName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Transport',
      headerName: 'Transport',
      field: 'transport',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'iconsOfTransport',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: false,
      sortable: false,
    });

    this.innedGridActionAccess(fromEdit) &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        cellRendererParams: {
          showDelete: true,
          value: 'customTransportMulti',
          deleteData: (data: any) => {
            this.alertConfirmationForMultipleCustomTransportData(data);
          },
        },
        sortable: false,
        lockVisible: true,
        lockPosition: right,
        maxWidth: grid_widths_map.sm_column_xm,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        resizable: false,
      });
    return colDef;
  }

  alertConfirmationForMultipleCustomTransportData(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.CustomFacade.deleteMultipleTransportScenarioActions(data, 'delete');
      }
    });
  }

  deleteCustomConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteTransportSub.next([data, customType, pathName]);
      }
    });
  }

  isEmpty(val: any) {
    if (val !== undefined || val !== null || val !== '') {
      val = val.trim();
    }
    return val === undefined || val === null || val === '';
  }
}
